import noop from 'lodash/noop'
import { Cookies } from 'react-cookie'

import { storageAvailable } from '@Globals/Storage'

let cookieInstance: Cookies

// This handler is really just to avoid having to instantiate the library each time. Which doesn't
// really make sense until we start spinning up a SPA, but hey, at least then we'll be prepared, right?
const getCookieInstance = (): typeof cookieInstance => {
  if (!cookieInstance) {
    cookieInstance = new Cookies()
  }

  return cookieInstance
}

const getStorage = (): Storage => {
  if (storageAvailable('sessionStorage')) {
    return window.sessionStorage
  }

  if (storageAvailable('localStorage')) {
    return window.localStorage
  }

  throw new Error('no storage available')
}

export const trackProductClick = (productID: string, variantID?: string, customerID?: string) => {
  // exclude events from gift card to recommendations
  if (productID === '26342') {
    return
  }

  let previousProductID: string | undefined
  try {
    const storage = getStorage()
    previousProductID = storage.getItem('th_last_product_id') ?? undefined
    storage.setItem('th_last_product_id', productID)
  } catch {
    // if localstorage isn't available, we just don't track the previous product
  }

  if (productID === previousProductID) {
    // don't track if the same product is clicked multiple times in a row
    return
  }

  try {
    fetch(
      `https://api.trendhim.com/v1/recommendation/track?${new URLSearchParams({
        track_type: 'product',
        customer_id: customerID || '',
        previous_product_id: previousProductID || '',
        product_id: productID,
        user_id: getCookieInstance().get('th_uid') ?? '',
        variant_id: variantID || '',
      })}`,
      {
        method: 'GET',
      },
    ).catch(noop)
  } catch {
    // Do NOTHING! We don't care.
  }
}

